import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { print } from "graphql/language/printer";
import gql from "graphql-tag";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// Define a type for the slice state
interface TrainingCoursesState {
  courses: any | undefined;
  init: boolean;
}

// Define the initial state using that type
const initialState: TrainingCoursesState = {
  courses: undefined,
  init: false,
};

export const trainingCoursesSlice = createSlice({
  name: "training-courses",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setInit: (state, action: PayloadAction<boolean>) => {
      state.init = action.payload;
    },
  },
});

export const trainingCoursesApi = createApi({
  reducerPath: "training-courses-api",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_GRAPHQL_API_URL,
    prepareHeaders: (headers, { getState }) => {
      headers.set("x-api-key", process.env.REACT_APP_GRAPHQL_API_KEY!);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCourses: builder.query<any, { id: string }>({
      query: (post) => {
        return {
          url: "",
          method: "POST",
          body: {
            query: print(gql`
              query GET_TRAINING_COURSES($id: ID!) {
                getPod(id: $id) {
                  id
                  pods {
                    items {
                      id
                      name
                    }
                  }
                }
              }
            `),
            variables: {
              id: post.id,
            },
          },
        };
      },
      transformResponse: (response: any) => {
        return response.data;
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCoursesQuery } = trainingCoursesApi;

export const { setInit } = trainingCoursesSlice.actions;

// Other code such as selectors can use the imported `RootState` type
//export const selectCount = (state: RootState) => state.counter.value;

export default trainingCoursesSlice.reducer;
